import { AppGlobalContext } from 'contexts/GlobalContext';
import useCountriesData from '../Queries/countriesQuery';
import { useContext } from 'react';

export default function useCurrentMasterCountry() {
	const countriesQuery = useCountriesData();
	const { mainCountry } = useContext(AppGlobalContext);

	const currentMasterCountry = countriesQuery.data?.find(
		(y) => y.name.toLowerCase() === mainCountry.pais.toLowerCase()
	);

	return currentMasterCountry;
}
